import classNames from 'classnames';
import React from 'react';

import { PageLayoutHeader, type PageLayoutHeaderProps } from './PageLayoutHeader';

import './PageLayout.scss';

interface PageLayoutProps extends PageLayoutHeaderProps {
	children: React.ReactNode;
	className?: string;
}

/**
 * Standard page layout component for admin portal pages.
 * Ensures consistent padding, spacing, and title styling across all pages.
 */
export const PageLayout: React.FC<PageLayoutProps> = ({
	title,
	breadcrumb,
	size = 'heading',
	trailingContent,
	children,
	className,
}) => {
	return (
		<div className={classNames('page-layout', className)}>
			<PageLayoutHeader
				title={title}
				breadcrumb={breadcrumb}
				size={size}
				trailingContent={trailingContent}
			/>
			<div className='page-layout__content'>{children}</div>
		</div>
	);
};
